import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../navigation/mainNavBar";
import { useCookies } from "react-cookie";
import "./Application.scss";

import Footer from "../footer/Footer";
import Form from "./Form";

function Application() {
  let navigate = useNavigate();
  const [UserData, setUserData] = useState({});

  const routeChange2 = (link) => {
    navigate(link);
  };

  const [cookies, setCookie, removeCookie] = useCookies(["accept-cookies"]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = document.hidden
        ? "Nieładnie tak ściągać przy pisaniu!!🤠"
        : "WildLandsRP.pl - Polski Serwer RP RDR2";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (!cookies["accept-cookies"]) {
      let path = `/`;
      navigate(path);
      return () => {};
    }
    fetch("./login.php", {
      // credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        setUserData(data);
        if (!data.logged) {
          let path = `/`;
          navigate(path);
        }
      });
  }, []);

  return (
    <div className="Application">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">Informacje</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          Proces rozpatrywania podań najczęściej zajmuje do 24 godzin, jednakże
          istnieją okoliczności, w których może to potrwać nawet do siedmiu dni.
          Stawiamy na dokładność i analizę indywidualną, co może wydłużyć czas
          oczekiwania. Dołożymy jednak wszelkich starań, aby podanie zostało jak
          najszybciej rozpatrzone.
        </div>
        <div className="grid-item"></div>
      </section>
      <section className="grid">
        <div className="grid-item">
          <h3>Wiek</h3>
          Aby móc dołączyć do naszego serwera, konieczne jest osiągnięcie wieku
          szesnastu lat. Niemniej jednak, zdarzają się sytuacje wyjątkowe, w
          których decyzję podejmuje indywidualnie administracja.
          {/* <img src={cowboy_image}></img> */}
        </div>
        <div className="grid-item">
          <h3>Sprzęt i Aplikacje</h3>
          Aby cieszyć się pełnią rozgrywki na naszym serwerze, niezbędne jest
          wyposażenie się w funkcjonalny mikrofon. Dodatkowo, będziesz
          potrzebował aplikacji Discord oraz RedM, kopi gry Red Dead Redemption
          2 lub Red Dead Online.
        </div>

        <div className="grid-item">
          <h3>Regulamin</h3>
          Zapoznanie się z regulaminem jest niezbędne, aby móc korzystać z
          serwisu w sposób odpowiedzialny i zgodny z przyjętymi normami, co
          wpływa na komfort i bezpieczeństwo użytkowników.
        </div>
      </section>
      <div className="section-title">Przydatne Linki</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          Znajdziesz tutaj kilka niezwykle przydatnych linków, które pomogą Ci
          zgłębić tajniki naszego serwera RP oraz lepiej zrozumieć panujące
          tutaj zasady. Przeczytanie ich nie tylko ułatwi Ci proces zdawania
          Whitelisty, ale również pozwoli uniknąć problemów z rozgrywką w
          przyszłości. Dlatego serdecznie polecamy skorzystanie z tych źródeł i
          w pełni cieszenie się wspaniałą atmosferą naszego serwera RP.
        </div>
        <div className="grid-item"></div>
      </section>
      <section className="grid3">
        <div className="grid-item">
          <h3>Regulamin</h3>W tej sekcji znajdziesz zbiór zasad, które
          obowiązują na naszym serwerze. Zapoznanie się z nim pozwoli uniknąć
          nieporozumień i zapewni przyjemną grę dla wszystkich.
          <br />
          <button
            className="rounded-button"
            onClick={() => routeChange2("/rules")}
          >
            Regulamin
          </button>
        </div>
        <div className="grid-item">
          <h3>Konstytucja</h3>
          Zbiór zasad, które regulują funkcjonowanie hrabstwa na naszym
          serwerze. Jest to ważny dokument, który określa strukturę władzy oraz
          prawa i obowiązki obywateli. Dzięki niej gracze mogą lepiej zrozumieć
          polityczne tło rozgrywki.
          <br />
          <button className="rounded-button">Konstytucja</button>
        </div>
        <div className="grid-item">
          <h3>Poradnik RolePlay</h3>
          Zawiera wiele cennych wskazówek na temat tworzenia postaci i
          prowadzenia rozmów w grze. RolePlay to kluczowy element naszej
          rozgrywki, dlatego warto poznać jego zasady i nauczyć się jak
          najlepiej wcielać się w swoją postać.
          <br />
          <button
            className="rounded-button"
            onClick={() => routeChange2("/roleplay")}
          >
            Poradnik RolePlay
          </button>
        </div>
        <div className="grid-item">
          <h3>Poradnik Medycznego RP</h3>
          Znajdziesz tutja wiele cennych wskazówek, które pozwolą Ci na lepsze
          odgrywanie medycznego RP. Jest tam wytłumaczone jak działa karta
          pacjenta, oraz w jaki sposób ją poprawnie uzupełniać.
          <br />
          <button
            className="rounded-button"
            onClick={() => routeChange2("/medrp")}
          >
            Poradnik Medycznego RP
          </button>
        </div>
      </section>
      <Form userData={UserData} />
      <Footer />
    </div>
  );
}

export default Application;
